import { Icon } from '@ui-lib/components/lib/models/icon.model';
import { EquipmentStatuses } from '../../core/openapi/bff-admin-api';

type EquipmentStatusData = {
  icon: Icon;
  className: string;
  chipClassName: string;
  translationKey: string;
};

const EQUIPMENT_STATUS_DATA: Record<EquipmentStatuses, EquipmentStatusData> = {
  // [EquipmentStatuses.InRepair]: {
  //   icon: 'screwdriver',
  //   className: 'repair',
  //   chipClassName: 'status-chip--repair',
  //   translationKey: 'monitoring.devices.status.repair',
  // },
  [EquipmentStatuses.Defect]: {
    icon: 'danger-alt',
    className: 'malfunction',
    chipClassName: 'status-chip--malfunction',
    translationKey: 'monitoring.devices.status.malfunction',
  },
  [EquipmentStatuses.Working]: {
    icon: 'pick',
    className: 'working',
    chipClassName: 'status-chip--working',
    translationKey: 'monitoring.devices.status.working',
  },
  [EquipmentStatuses.Disabled]: {
    icon: 'power',
    className: 'disabled',
    chipClassName: 'status-chip--disabled',
    translationKey: 'monitoring.devices.status.disabled',
  },
  // «Не найден»: скан не увидел аппарат на месте. Отличается от Disabled — держится
  // до следующего скана или до успешного опроса, поэтому и вид у него отдельный.
  [EquipmentStatuses.Offline]: {
    icon: 'internet-off',
    className: 'offline',
    chipClassName: 'status-chip--offline',
    translationKey: 'monitoring.devices.status.offline',
  },
};

const getEquipmentStatusData = (status: EquipmentStatuses): EquipmentStatusData => {
  return EQUIPMENT_STATUS_DATA[status];
};

export const getEquipmentStatusIcon = (status: EquipmentStatuses): Icon => {
  return getEquipmentStatusData(status).icon;
};

export const getEquipmentStatusClassName = (status: EquipmentStatuses, prefix = ''): string => {
  return prefix + getEquipmentStatusData(status).className;
};

export const getEquipmentStatusChipClassName = (status: EquipmentStatuses): string =>
  getEquipmentStatusData(status).chipClassName;

export const getEquipmentStatusTranslationKey = (status: EquipmentStatuses): string =>
  getEquipmentStatusData(status).translationKey;
